import { useEffect, useState } from 'react';
import { useI18nContext } from '@/i18n/i18n-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

export interface AudienceEditNameDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  name: string;
  title?: string;
  onConfirm: (name: string) => void;
}

export function AudienceEditNameDialog({
  open,
  onOpenChange,
  name,
  title,
  onConfirm,
}: AudienceEditNameDialogProps) {
  const { LL } = useI18nContext();
  const [draft, setDraft] = useState(name);
  const dialogTitle = title ?? LL.audiences.create.editNameDialog.title();

  useEffect(() => {
    if (open) {
      setDraft(name);
    }
  }, [open, name]);

  const handleConfirm = () => {
    onConfirm(draft.trim() || name);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{dialogTitle}</DialogTitle>
        </DialogHeader>
        <Input
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          placeholder={LL.audiences.create.defaultName()}
          autoFocus
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleConfirm();
            }
          }}
        />
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            {LL.audiences.create.editNameDialog.cancel()}
          </Button>
          <Button type="button" onClick={handleConfirm}>
            {LL.audiences.create.editNameDialog.ok()}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
